module.exports = __webpack_public_path__ + "img/share-bg-16.1d898367.jpg";